import { useEffect, useRef, type ReactNode } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface InfiniteScrollProps {
  children: ReactNode;
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
}

export function InfiniteScroll({
  children,
  hasMore,
  isLoading,
  onLoadMore,
}: InfiniteScrollProps) {
  const observerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !isLoading) {
          onLoadMore();
        }
      },
      { threshold: 0.1 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => observer.disconnect();
  }, [hasMore, isLoading, onLoadMore]);

  return (
    <div>
      {children}
      <div ref={observerRef} className="h-10">
        {isLoading && <LoadingSpinner />}
        {!hasMore && !isLoading && (
          <p className="text-center text-dim py-10 font-display text-sm">
            You've reached the end
          </p>
        )}
      </div>
    </div>
  );
}
